import { render, staticRenderFns } from "./AgeLabel.vue?vue&type=template&id=78a312b1&"
import script from "./AgeLabel.vue?vue&type=script&lang=js&"
export * from "./AgeLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports